module.exports = __webpack_public_path__ + "bn.c5b91605c852ec62583c.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/portal/bullseye/node_modules/flag-icon-css/flags/1x1/bn.svg
// module id = ../../../../flag-icon-css/flags/1x1/bn.svg
// module chunks = styles